<template>
  <v-simple-table style="width:100%;">
    <thead>
      <tr>
        <th class="primary--text">{{ $i18n.t("Account") }}</th>
        <th class="primary--text">{{ $i18n.t("Title") }}</th>
        <th class="primary--text">{{ $i18n.t("Date") }}</th>
        <th class="primary--text">{{ $i18n.t("Start") }}</th>
        <th class="primary--text">{{ $i18n.t("Expiry") }}</th>
        <th class="primary--text">{{ $i18n.t("Issuing Authority") }}</th>
        <th class="primary--text">{{ $i18n.t("Fare") }}</th>
        <th class="text-right primary--text"></th>
      </tr>
    </thead>

    <tbody v-if="grid != null">
      <tr v-for="(expense, index) in grid.rows" :key="index">
        <td>
          <span
            v-if="expense.accountCode == 'DriverCashAdvance'"
          >{{ $i18n.t("Driver Cash Advance") }}</span>
          <span
            v-if="expense.accountCode == 'TripExpenseAdvance'"
          >{{ $i18n.t("Trip Expense Advance") }}</span>
          <span
            v-if="expense.accountCode == 'TripExpenseReturn'"
          >{{ $i18n.t("Trip Expense Return") }}</span>
          <span v-if="expense.accountCode == 'DriverFundReturn'">{{ $i18n.t("Driver Fund Return") }}</span>
          <span v-if="expense.accountCode == 'Salary'">{{ $i18n.t("Salary") }}</span>
          <span v-if="expense.accountCode == 'SalaryAdvance'">{{ $i18n.t("Salary Advance") }}</span>
        </td>
        <td>{{ expense.title }}</td>
        <td>
          {{ formatDate(expense.date) }}
          <br />
          {{ expense.forMonth ? 'For month : ' + formatDate(expense.forMonth) : ''}}
        </td>
        <td>{{ formatDate(expense.affectFrom) }}</td>
        <td>{{ formatDate(expense.expiry) }}</td>
        <td>{{ expense.vendor_id != null && expense.vendor_id != 'null' ? expense.vendorName : expense.organization.name }}</td>
        <td>{{ expense.fare.currency }} {{ expense.fare.total }}</td>
        <td>
          <z-confirm-button
            class="float-right"
            color="red lighten-1"
            x-small
            fab
            text
            :loading="loading"
            :message="$i18n.t('Do you want to delete this Expense ?')"
            @click="deleteExpense(expense._id)"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
          </z-confirm-button>
          <v-btn class="float-right" text fab x-small color="blue" :href="'/expense/'+expense._id">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "Expenses",
  props: {
    value: {
      default: null,
    },
    expenseType: {
      default: null,
    },
    entity_id: {
      default: null,
    },
  },
})
export default class Expenses extends Vue {
  grid = null;

  async mounted() {
    let url =
      "/api/expense/grid?_search=true&rows=30&driver_id=" + this.entity_id;

    if (this.expenseType == "Insurance") {
      url = url + "&accountCode=DriverExpense&serviceType=Insurance";
    } else if (this.expenseType == "Permits") {
      url = url + "&accountCode=DriverExpense&serviceType=Permits";
    } else if (this.expenseType == "Expenses") {
      url =
        url +
        "&accounts=DriverCashAdvance,DriverFundReturn,Salary,SalaryAdvance,DriverExpense,TripExpenseAdvance,TripExpenseReturn";
    }

    this.grid = await doGet(url);
  }

  async deleteExpense(expense_id) {
    common.setLoading(true);
    try {
      await doGet("/api/expense/" + expense_id + "/delete");
      common.showMessage("Deleted Successfully");
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>
